import { useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { http } from '../../AxiosConfig'
import { FORM_VALUE } from '../../Cookies'
import toast from 'react-hot-toast'
import UserCard from '../UserCard/UserCard'
import { reimbursementOptions } from '../../data'
import FormLoader from '../FormLoader/FormLoader'
import { MainContext } from '../MainContext'
import { toSnakeCase } from '../../components/library'

const REIMBURSEMENT_ITEM_TYPES = ['Reimbursement', 'Per Diem', 'Mileage']

const ReimbursementSelector = ({ ...props }) => {
  const form = useRef()
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const [isDisabled] = useState(true)
  const [activeForm, setActiveForm] = useState('Reimbursement')
  const { user, selectedTerm, setReimbursementItem, reimbursement } =
    useContext(MainContext)
  const loadedFormValues = localStorage.getItem(FORM_VALUE)
    ? JSON.parse(localStorage.getItem(FORM_VALUE))
    : {
        reimbursement_id: reimbursement.id,
        type: activeForm,
        name: '',
        expense_date: '',
        amount: '',
        units: '',
        receiptFile: '',
        notes: '',
      }
  const [reimbursementFormValues, setReimbursementFormValues] =
    useState(loadedFormValues)

  const handleSubmit = e => {
    e.preventDefault()
    // localStorage.setItem(FORM_VALUE, JSON.stringify(reimbursementFormValues))
    const data = new FormData(form.current)
    Object.keys(reimbursementFormValues).forEach(key => {
      data.append(`reimbursement_item[${key}]`, reimbursementFormValues[key])
    })
    data.append('reimbursement_item[type]', toSnakeCase(activeForm))

    addReimbursementItem(data)
  }

  function addReimbursementItem(valueData) {
    setIsLoading(true)
    http
      .post('/reimbursement_items', valueData)
      .then(res => {
        setReimbursementItem(res.data.data.attributes)
        return res
      })
      .then(res => {
        if (res.data.data.attributes.type === 'per_diem') {
          navigate('/Review')
        }
        else {
          navigate('/FileUpload')
        }
      })
      .catch(err => {
        console.log('Error:', err.message)
        toast.error('Could not process reimbursement item.')
        setIsLoading(false)
      })
  }
  const handleChange = e => {
    setReimbursementFormValues(values => ({
      ...values,
      [e.target.name]: e.target.value,
    }))
    if (e.target.value === 'housing') {
      document
        .getElementById('name')
        .focus({ focusVisible: true, preventScroll: false })
    }
  }

  const unitTypeLabel = () => {
    if (activeForm === 'Reimbursement') {
      return 'Quantity'
    }
    else if (activeForm === 'Per Diem') {
      return 'Days'
    }
    else if (activeForm === 'Mileage') {
      return 'Miles Driven'
    }
  }

  const changeFormFields = current => {
    setActiveForm(current)
    const oldValues = reimbursementFormValues
    if (current === 'Reimbursement') {
      if (!reimbursementFormValues.hasOwnProperty('category')) {
        delete oldValues.per_diem_start
        setReimbursementFormValues(values => ({
          ...oldValues,
          ['category']: '',
        }))
      }
    }
    else if (current === 'Per Diem') {
      delete oldValues.category
      delete oldValues.expense_date

      setReimbursementFormValues(values => ({
        ...oldValues,
        ['per_diem_start']: '',
      }))
    }
    else if (current === 'Mileage') {
      delete oldValues.category
      delete oldValues.per_diem_start
    }
  }
  function unitWith() {
    switch (activeForm) {
    case 'Per Diem':
      return 'w-full'
    case 'Mileage':
      return 'w-full'
    case 'Reimbursement':
      return 'w-2/3'
    }
  }
  function gridInput() {
    switch (activeForm) {
    case 'Reimbursement':
      return 'grid gap-4 grid-cols-2 '
    case 'Per Diem':
      return ''
    case 'Mileage':
      return ''
    }
  }

  const buttonClass = active => (active === activeForm ? 'active' : 'inactive')

  return (
    <div className="container max-w-screen-lg mx-auto pt-10 pb-10">
      <div className="bg-gradient-to-r bg-white border border-zinc-200 dark:border-zinc-700  sm:p-6 dark:bg-zinc-600">
        <UserCard user={user} term={selectedTerm} />
      </div>
      <span className="grid gap-0 place-content-center grid-cols-3">
        {/* place-content-center */}
        {REIMBURSEMENT_ITEM_TYPES.map(c => (
          <button
            className={`mt-9 font-semibold leading-none text-white py-4 
	                bg-cyan-700 hover:bg-cyan-400 
	                focus:ring-0 center focus:outline-none ${buttonClass(c)} `}
            key={c}
            id={c}
            onClick={() => changeFormFields(c)}
          >
            {c}
          </button>
        ))}
      </span>
      <div className="bg-zinc-800 shadow p-10">
        <div>
          <form ref={form} onSubmit={handleSubmit}>
            <div className="md:flex items-center mt-4">
              <div className="w-full flex flex-col">
                <label htmlFor="name">Reimbursement Name</label>
                <input
                  onChange={handleChange}
                  value={reimbursementFormValues.name}
                  id="name"
                  name="name"
                  className="primary-input"
                  type="text"
                  placeholder="eg:4 nights hotel"
                  autoComplete="off"
                  required
                ></input>
              </div>
            </div>
            <div>
              {reimbursementFormValues.category === 'housing' ? (
                <p className="text-yellow-300">
                  <b>
                    Reimbursement Name for Housing should be formatted as:
                    <br />
                  </b>
                  <span className="text-amber-600">
                    Housing for July (07-01-2022 - 08/03/2022)
                  </span>
                </p>
              ) : null}{' '}
            </div>
            {activeForm === 'Per Diem' ? null : (
              <div className="md:flex items-center mt-4">
                <div className="w-full flex flex-col">
                  <label htmlFor="date">Date of Transaction</label>
                  <input
                    id="expense_date"
                    name="expense_date"
                    placeholder="Date Of Transaction"
                    value={reimbursementFormValues.expense_date}
                    type="date"
                    className="primary-input"
                    onChange={handleChange}
                    autoComplete="off"
                    required
                  ></input>
                </div>
              </div>
            )}

            <div className={[gridInput(), 'overflow-hidden md'].join('')}>
              {activeForm === 'Reimbursement' ? (
                <div>
                  <label
                    htmlFor="amount"
                    className="block py-2.5 px-0 w-full text-center text-gray-300"
                  >
                    Amount
                  </label>
                  <input
                    onChange={handleChange}
                    value={reimbursementFormValues.amount}
                    id="amount"
                    placeholder="$"
                    name="amount"
                    type="number"
                    className="primary-input w-2/3"
                    step=".01"
                    autoComplete="off"
                    required
                  ></input>
                </div>
              ) : null}
              <div className="relative z-0 w-full mb-6 group">
                <label
                  htmlFor="name"
                  className="block py-2.5 px-0 w-full text-gray-300"
                >
                  {unitTypeLabel()}
                </label>
                <input
                  onChange={handleChange}
                  value={reimbursementFormValues.units}
                  id="units"
                  name="units"
                  className={['primary-input', unitWith()].join(' ')}
                  type="number"
                  step="1"
                  autoComplete="off"
                  required
                ></input>
              </div>
            </div>
            {activeForm === 'Per Diem' ? (
              <div className="md:flex items-center mt-4">
                <div className="w-full flex flex-col">
                  <label htmlFor="date">Starting Date</label>
                  <input
                    id="per_diem_start"
                    name="per_diem_start"
                    className="reimbursement-input"
                    placeholder="Date Of Transaction"
                    value={reimbursementFormValues.per_diem_start}
                    type="date"
                    onChange={handleChange}
                    autoComplete="off"
                    required
                  ></input>
                </div>
              </div>
            ) : null}

            {activeForm === 'Reimbursement' ? (
              <div className="md:flex items-center mt-4">
                <div className="w-full flex flex-col">
                  <label htmlFor="name">Category</label>
                  <select
                    onChange={handleChange}
                    id="category"
                    className="reimbursement-input"
                    name="category"
                    defaultValue={reimbursementFormValues.category}
                    required
                  >
                    {reimbursementOptions.map(c => (
                      <option key={c.value} value={c.value}>
                        {c.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ) : null}

            <div className="md:flex items-center mt-4">
              <div className="w-full flex flex-col">
                <label htmlFor="notes">Notes</label>
                <textarea
                  onChange={handleChange}
                  value={reimbursementFormValues.notes}
                  id="notes"
                  name="notes"
                  className="reimbursement-input"
                  type="text"
                  autoComplete="off"
                  required
                ></textarea>
              </div>
            </div>

            <div>
              {isLoading ? (
                <button
                  id="continue-button-loader"
                  className="primary-button"
                  disabled={isDisabled}
                >
                  <FormLoader message={`Loading`} />
                </button>
              ) : (
                <button
                  id="continue-button-selector"
                  className="primary-button"
                  type="submit"
                >
                  Continue -&gt; File Upload
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
      <div>
        {/* <button >Add Another</button> */}
        {/* <button color="green" onClick={()=>setAdding(!adding)} size="mini">{adding ? "Cancel" : "Save & Add Reinbursement"}</button>
	{adding && getCurrentFormComponent()}
      <button type="submit" >I'm Done</button> */}
      </div>
    </div>
  )
}
export default ReimbursementSelector
